import React from 'react';
import { Modal, View, ScrollView, Pressable, StyleSheet } from 'react-native';
import { DataTable } from 'react-native-paper';
import { Feather } from '@expo/vector-icons';

import { useResponsiveStyles } from '../../hooks';

const KPIModal = ({ visible, onClose, labels, datasetDetails }) => {
  const { isWeb } = useResponsiveStyles();

  return (
    <Modal
      style={styles.modal}
      visible={visible}
      transparent={false}
      onRequestClose={onClose}
    >
      <Pressable
        onPress={onClose}
        style={({ pressed, hovered, focused }) => [
          styles.closeButton,
          !isWeb && styles.closeButtonMobile,
          { cursor: 'pointer' },
          (hovered || focused) && styles.closeButtonHovered,
          pressed && styles.pressed,
        ]}
        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
      >
        <Feather
          name="x"
          size={isWeb ? 24 : 28}
          color="#6B7280"
        />
      </Pressable>

      <ScrollView>
        <DataTable>
          <DataTable.Header style={isWeb ? {} : {}}>
            <DataTable.Title style={!isWeb ? styles.titleCell : {}} />
            {labels &&
              labels.map((label, index) => (
                <DataTable.Title
                  key={index}
                  numeric
                  style={
                    !isWeb && labels.length > 7
                      ? {}
                      : !isWeb
                        ? { transform: 'rotate(45deg)' }
                        : {}
                  }
                >
                  {!isWeb && labels.length > 7 ? '' : label}
                </DataTable.Title>
              ))}
          </DataTable.Header>
          {datasetDetails.length > 0 &&
            datasetDetails.map((obj, index) => (
              <DataTable.Row key={index}>
                <DataTable.Title style={!isWeb ? styles.rowTitleCell : {}}>
                  {obj.label}
                </DataTable.Title>
                {obj.dataset['data'].map((value, i) => (
                  <DataTable.Cell numeric key={i}>
                    {value}
                  </DataTable.Cell>
                ))}
              </DataTable.Row>
            ))}
        </DataTable>
      </ScrollView>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modal: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: '#FFFFFF',
  },
  // V3: Close button with proper touch target (44x44 minimum)
  closeButton: {
    alignSelf: 'flex-start',
    marginLeft: 12,
    marginTop: 12,
    width: 44,
    height: 44,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 22,
  },
  closeButtonHovered: {
    backgroundColor: '#F9FAFB',
  },
  closeButtonMobile: {
    marginTop: 44,
  },
  // V3: Visual feedback on press
  pressed: {
    backgroundColor: '#F3F4F6',
  },
  titleCell: {
    minWidth: 65,
  },
  rowTitleCell: {
    minWidth: 80,
  },
});

export default KPIModal;
